import { render, staticRenderFns } from "./ToolbarAdmin.vue?vue&type=template&id=1c96fcb2&scoped=true&"
import script from "./ToolbarAdmin.vue?vue&type=script&lang=js&"
export * from "./ToolbarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarAdmin.vue?vue&type=style&index=0&id=1c96fcb2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96fcb2",
  null
  
)

component.options.__file = "ToolbarAdmin.vue"
export default component.exports